import { existNewbuildingIdInStorage } from './existNewbuildingIdInStorage';
import { PHONE_SHOWED_STORAGE_KEY } from '../../constants/lastHopePopup';

export function isUserOpenedPhoneInNewobject(newobjectId: number): boolean {
  return existNewbuildingIdInStorage(PHONE_SHOWED_STORAGE_KEY, newobjectId);
}
